import React from 'react';
import { inject } from 'mobx-react';

import * as RS from 'reactstrap';

import { ValueTextEdit } from './ValueTextEdit';

export var EntryFieldsPane = inject('controlsStore')(function (_ref) {
  var controlsStore = _ref.controlsStore,
      type = _ref.type,
      tabID = _ref.tabID,
      fields = _ref.fields;

  if (!fields) {
    var key = 'tab.' + type + '.' + tabID;
    fields = ((controlsStore.valuesByKey[key] || {}).value || '').split(',');
  }
  return React.createElement(
    RS.TabPane,
    { tabId: tabID },
    fields.map(function (field) {
      return React.createElement(ValueTextEdit, { key: field, field: field });
    })
  );
});